<style>
	 @import '@/assets/css/custom.css';

	/* Stock Notice Alert Animation */
	.stock-notice-alert {
		animation: slideInBounce 0.6s ease-out;
		border-left: 5px solid;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		position: relative;
		overflow: hidden;
		color: #8b0000 !important;
		font-weight: 600;
	}

	.stock-notice-alert::before {
		content: '';
		position: absolute;
		top: 0;
		left: -100%;
		width: 100%;
		height: 100%;
		background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
		animation: shimmer 2s infinite;
	}

	.stock-notice-alert strong {
		color: #6b0000 !important;
		font-weight: 700;
	}

	.stock-notice-alert.alert-warning {
		border-left-color: #ff9800;
		background-color: #fff8e1;
		color: #8b0000 !important;
	}

	.stock-notice-alert.alert-warning strong {
		color: #6b0000 !important;
		font-weight: 700;
	}

	.stock-notice-alert.alert-info {
		border-left-color: #17a2b8;
		background-color: #e7f3f5;
		color: #8b0000 !important;
	}

	.stock-notice-alert.alert-info strong {
		color: #6b0000 !important;
		font-weight: 700;
	}

	@keyframes slideInBounce {
		0% {
			transform: translateX(-100%);
			opacity: 0;
		}
		60% {
			transform: translateX(10px);
			opacity: 1;
		}
		80% {
			transform: translateX(-5px);
		}
		100% {
			transform: translateX(0);
			opacity: 1;
		}
	}

	@keyframes shimmer {
		0% {
			left: -100%;
		}
		100% {
			left: 100%;
		}
	}

	/* Icon animation */
	.stock-notice-alert i {
		display: inline-block;
		animation: bounceIcon 1.5s ease-in-out infinite;
	}

	@keyframes bounceIcon {
		0%, 100% {
			transform: translateY(0);
		}
		50% {
			transform: translateY(-5px);
		}
	}
</style>

<template>
    <div>
        <Breadcrumbs main="Service Management" title="Support Services" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'add_complaint' }" class="btn btn-primary float-end">Add Service</router-link>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchServices()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="date" class="form-control ms-1 float-end" placeholder="Search" v-model="date_filter" @change="fetchServices()" />
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchServices()">
											<option value="">All</option>
                                            <option value="1">Pending</option>
											<option value="2">Ongoing</option>
                                            <option value="3">Completed</option>
											<option value="4">Manufacturer</option>
											<option value="5">Assigned to Speedtech</option>
											<option value="6">Assigned to Dealer</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @input="fetchServices()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>IMEI</th>
											<th>Contact</th>
											<th>Service Type</th>
											<th>Date</th>
											<th>Added By</th>
                                            <th>Status</th>
											<th>Amount</th>
											<th>Payment Data</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(services.length)">
										<tr v-for="(service, index) in services" :key="service.id" align="center">
                                            <td>{{ index + 1 }}</td>
											<td>
												<b>IMEI:-</b>{{ service.imei }} <br> 
												<b>ICCID:-</b>{{ service.iccid }} <br>
												<b>SIM Provider:-</b>{{ service.sim_provider || '-' }}<br>
												<b>Dealer:-</b>{{ [service.dealer_name, service.dealer_last_name].filter(Boolean).join(' ') || '-' }}<br>
											</td>
											<td>
												<span v-if="service.vehicle_no">Vehicle No: {{ service.vehicle_no }}</span>
												<br>
												<span v-if="service.mobile">Contact: {{ service.mobile }}</span>
											</td>
											<td>
												<b>{{ service.service_type == 1 ? 'SIM Change' : service.service_type == 2 ? 'Repair' : service.service_type == 3 ? 'Replacement' : service.service_type == 4 ? 'No Data' : service.service_type == 5 ? 'Tracking Issue' : service.service_type == 6 ? 'Hardware Issue' : service.service_type == 7 ? 'Software Issue' : service.service_type == 8 ? 'Alert Fail' : service.service_type == 9 ? 'Other' : 'N/A' }}</b>
												<span class="badge rounded-pill bg-info" v-if="service.work_status==1">Pending</span>
												<span class="badge rounded-pill bg-success" v-if="service.work_status==2">Completed</span>

                                                <span v-if="service.work_type !== null"> 
                                                    <span class="badge rounded-pill bg-primary" v-if="service.work_type==1">On Field</span>
                                                    <span class="badge rounded-pill bg-secondary" v-if="service.work_type==2">At Office</span>
                                                </span>
											</td>
											<td>{{ service.created_date }}</td>
											<td>{{ service.added_user_name }}</td>
											<td>
												<span class="badge rounded-pill bg-info" v-if="service.status==1">Pending</span>
												<span class="badge rounded-pill bg-warning" v-if="service.status==2">Ongoing</span>
												<span class="badge rounded-pill bg-success" v-if="service.status==3">Completed</span>
												<span class="badge rounded-pill bg-secondary" v-if="service.status==4">To Vendor</span>
												<span class="badge rounded-pill bg-primary" v-if="service.status==5">Component Replacement</span>
											</td>
											<td>
												<span v-if="service.total_amount">
													Total: ₹{{ service.total_amount }} <br>
													Online: ₹{{ service.cash_online ? service.cash_online : '0.00' }} <br>
													Cash: ₹{{ service.cash_in_hand ? service.cash_in_hand : '0.00' }} <br>
													Balance: ₹{{ service.balance_amount ? service.balance_amount : '0.00' }}
												</span>
											</td>
											<td>
												Payment Type: <span class="badge rounded-pill bg-primary" v-if="service.payment_type==1">Online</span>
												<span class="badge rounded-pill bg-secondary" v-if="service.payment_type==2">Cash</span>
												<span class="badge rounded-pill bg-success" v-if="service.payment_type==3">Both</span>
												<br>
												Payment Status: <span class="badge rounded-pill bg-success" v-if="service.payment_status==1">Received</span>
												<span class="badge rounded-pill bg-danger" v-if="service.payment_status==2">Not Received</span>
												<span class="badge rounded-pill bg-warning" v-if="service.payment_status==3">Partially Received</span>
											</td>
                                            <td>
												<button v-if="service.status === 1" class="btn btn-light btn-sm mt-1 me-2" @click="assignToSpeedtech(service.id)">Assign to Speedtech</button>
												<router-link :to="{ name: 'complaint_details', params: { id: service.id } }" class="btn btn-primary btn-sm me-2 mt-1">Details</router-link>
											    <button class="btn btn-success btn-sm mt-1" @click="openCompletedModal(service.id)" :disabled="service.work_status === 1">Completed</button>
                                            </td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(services.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchServices(page.url + '&limit=' + listing_length + '&status=' + status + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Status<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="complaint_status">
								<option value="">--Select--</option>
								<option value="1">Completed</option>
							</select>
                        </div>
                    </div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Material Change<span class="text-danger">*</span></label>
						<select class="form-select" v-model="material_change">
							<option value="">--Select--</option>
							<option value="1">Yes</option>
							<option value="2">No</option>
						</select>
					</div>

					<div class="row">
						<div class="col-md-6 form-group mt-2" v-if="material_change == 1">
							<label class="control-label">Material<span class="text-danger">*</span></label>
							<select class="form-select" v-model="product_id">
								<option value="">--Select--</option>
								<option value="1">Material 1</option>
								<option value="2">Material 2</option>
								<option value="3">Material 3</option>
								<option value="4">Material 4</option>
							</select>
						</div>

						<div class="col-md-6 form-group mt-2" v-if="material_change == 1">
							<label class="control-label">Quantity<span class="text-danger">*</span></label>
							<input class="form-control" type="text" placeholder="" v-model="quantity"/>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2" v-if="complaint_status == 1">
						<label class="control-label">Total Amount<span class="text-danger">*</span></label>
						<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter total amount" v-model="cost"/>
					</div>

					<!-- Payment Status Section -->
					<div class="col-md-12 form-group mt-2" v-if="complaint_status == 1">
						<label class="control-label">Payment Status<span class="text-danger">*</span></label>
						<select class="form-select" v-model="payment_status">
							<option value="">--Select Payment Status--</option>
							<option value="received">Received</option>
							<option value="not_received">Not Received</option>
						</select>
					</div>

					<!-- Payment Type Section - Only show if payment is received -->
					<div class="col-md-12 form-group mt-2" v-if="complaint_status == 1 && payment_status == 'received'">
						<label class="control-label">Payment Type<span class="text-danger">*</span></label>
						<select class="form-select" v-model="payment_type" @change="onPaymentTypeChange">
							<option value="">--Select Payment Type--</option>
							<option value="1">Online</option>
							<option value="2">Cash</option>
							<option value="3">Both</option>
						</select>
					</div>

					<!-- Online Payment Details -->
					<div class="row" v-if="complaint_status == 1 && payment_status == 'received' && (payment_type == '1' || payment_type == '3')">
						<div class="col-md-6 form-group mt-2">
							<label class="control-label">Online Amount<span class="text-danger">*</span></label>
							<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="online_amount"/>
						</div>
						<div class="col-md-6 form-group mt-2">
							<label class="control-label">Payment ID<span class="text-danger">*</span></label>
							<input class="form-control" type="text" placeholder="Enter payment ID" v-model="payment_id"/>
						</div>
					</div>

					<!-- Cash Payment Details -->
					<div class="col-md-12 form-group mt-2" v-if="complaint_status == 1 && payment_status == 'received' && (payment_type == '2' || payment_type == '3')">
						<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
						<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="cash_amount"/>
					</div>

					<!-- Payment Validation Note -->
					<div class="col-md-12 mt-3" v-if="complaint_status == 1 && payment_status == 'received' && payment_type">
						<div class="alert alert-info">
							<small>
								<i class="icofont icofont-info-circle me-1"></i>
								<strong>Note:</strong> 
								<span v-if="payment_type === '1'">Online amount must equal total amount</span>
								<span v-else-if="payment_type === '2'">Cash amount must equal total amount</span>
								<span v-else-if="payment_type === '3'">Sum of online and cash amounts must equal total amount</span>
							</small>
						</div>
					</div>

					<!-- Payment Breakdown Display -->
					<div class="col-md-12 mt-2" v-if="complaint_status == 1 && payment_status == 'received' && payment_type && getPaymentBreakdown()">
						<div class="card border-light">
							<div class="card-body p-2">
								<div class="row text-center">
									<div class="col-md-3">
										<small class="text-muted">Total Amount</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().total }}</div>
									</div>
									<div class="col-md-3" v-if="payment_type === '1' || payment_type === '3'">
										<small class="text-muted">Online</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().online }}</div>
									</div>
									<div class="col-md-3" v-if="payment_type === '2' || payment_type === '3'">
										<small class="text-muted">Cash</small>
										<div class="fw-bold">₹{{ getPaymentBreakdown().cash }}</div>
									</div>
									<div class="col-md-3">
										<small class="text-muted">Status</small>
										<div class="fw-bold" :class="getPaymentBreakdown().isValid ? 'text-success' : 'text-danger'">
											{{ getPaymentBreakdown().isValid ? '✓ Valid' : '✗ Invalid' }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" @click="submitStatusUpdate">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>	

		<!-- Completed Modal -->
		<div class="modal fade" id="completedModal" tabindex="-1" aria-labelledby="completedModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="completedModalLabel">Completed</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitCompleted" enctype="multipart/form-data">
							<div class="col-md-12 mb-3" v-if="completedModalService && (completedModalService.payment_status != null || completedModalService.total_amount != null)">
								<div class="alert alert-light border">
									<strong>From service:</strong>
									<span v-if="completedModalService.payment_status != null">Payment Status: {{ paymentStatusLabel(completedModalService.payment_status) }}</span>
									<span v-if="completedModalService.payment_status != null && completedModalService.total_amount != null"> | </span>
									<span v-if="completedModalService.total_amount != null">Total Amount: {{ completedModalService.total_amount }}</span>
								</div>
							</div>
							<div class="col-md-12 form-group mt-2" v-if="payment_status != '4'">
								<label class="control-label">Total Amount<span class="text-danger">*</span></label>
								<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter total amount" v-model="cost"/>
							</div>
							<div class="col-md-12 form-group mt-2">
								<label class="control-label">Payment Status<span class="text-danger">*</span></label>
								<select class="form-select" v-model="payment_status">
									<option value="">--Select Payment Status--</option>
									<option value="1">Received</option>
									<option value="2">Not Received</option>
									<option value="4">Free Service</option>
								</select>
							</div>
							<div class="col-md-12 form-group mt-2" v-if="payment_status == '1' && payment_status != '4'">
								<label class="control-label">Payment Type<span class="text-danger">*</span></label>
								<select class="form-select" v-model="payment_type" @change="onPaymentTypeChange">
									<option value="">--Select Payment Type--</option>
									<option value="1">Cash</option>
									<option value="2">Online</option>
									<option value="3">Both</option>
								</select>
							</div>
							<div class="row" v-if="payment_status == '1' && payment_status != '4' && (payment_type == '2' || payment_type == '3')">
								<div class="col-md-6 form-group mt-2">
									<label class="control-label">Online Amount<span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="online_amount"/>
								</div>
								<div class="col-md-6 form-group mt-2">
									<label class="control-label">Payment ID<span class="text-danger">*</span></label>
									<input class="form-control" type="text" placeholder="Enter payment ID" v-model="payment_id"/>
								</div>
							</div>
							<div class="col-md-12 form-group mt-2" v-if="payment_status == '1' && payment_status != '4' && (payment_type == '1' || payment_type == '3')">
								<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
								<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="cash_amount"/>
							</div>
							<div class="col-md-12 mt-3" v-if="payment_status == '1' && payment_status != '4' && payment_type">
								<div class="alert alert-info">
									<small>
										<i class="icofont icofont-info-circle me-1"></i>
										<strong>Note:</strong> 
										<span v-if="payment_type === '2'">Online amount must equal total amount</span>
										<span v-else-if="payment_type === '1'">Cash amount must equal total amount</span>
										<span v-else-if="payment_type === '3'">Sum of online and cash amounts must equal total amount</span>
									</small>
								</div>
							</div>
							<div class="col-md-12 mt-2" v-if="payment_status == '1' && payment_status != '4' && payment_type && getPaymentBreakdown()">
								<div class="card border-light">
									<div class="card-body p-2">
										<div class="row text-center">
											<div class="col-md-3">
												<small class="text-muted">Total Amount</small>
												<div class="fw-bold">₹{{ getPaymentBreakdown().total }}</div>
											</div>
											<div class="col-md-3" v-if="payment_type === '2' || payment_type === '3'">
												<small class="text-muted">Online</small>
												<div class="fw-bold">₹{{ getPaymentBreakdown().online }}</div>
											</div>
											<div class="col-md-3" v-if="payment_type === '1' || payment_type === '3'">
												<small class="text-muted">Cash</small>
												<div class="fw-bold">₹{{ getPaymentBreakdown().cash }}</div>
											</div>
											<div class="col-md-3">
												<small class="text-muted">Status</small>
												<div class="fw-bold" :class="getPaymentBreakdown().isValid ? 'text-success' : 'text-danger'">
													{{ getPaymentBreakdown().isValid ? '✓ Valid' : '✗ Invalid' }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col-md-12 form-group mt-2">
								<label class="control-label">Remarks</label>
								<textarea class="form-control" placeholder="Enter remarks" v-model="remarks"></textarea>
							</div>
							<div class="modal-footer">
								<button type="submit" class="btn btn-primary" :disabled="isSubmittingCompleted">
									<span v-if="isSubmittingCompleted">
										<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										Submitting...
									</span>
									<span v-else>Update</span>
								</button>
								<button class="btn btn-light" type="button" @click="closeCompletedModal()" :disabled="isSubmittingCompleted">Close</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'

export default {
		name: "Pincode Page",
		components: {
			DynamicModal
		},
		setup(){
			let dynamicmodal;
			let completedModal;

			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
				completedModal = new Modal(document.getElementById('completedModal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			const showCompletedModal = () => {
				if (completedModal) {
					completedModal.show();
				} else {
					completedModal = new Modal(document.getElementById('completedModal'));
					completedModal.show();
				}
			}

			const hideCompletedModal = () => {
				if (completedModal) {
					completedModal.hide();
				}
			}

			return {
				showModal, hideModal,
				showCompletedModal, hideCompletedModal
			}
		},
		
		data() {
			return {
				
				modal_title: "Update Service Status",
				button_title: "Save",

				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},
				status:"",

                button_title: "Save",
                name: "",
				technician: "",

				complaint_status: 1,
				material_change: '',
				product_id: '',
				quantity: '',
				cost: '',
				payment_status: '',
				payment_type: '',
				online_amount: '',
				cash_amount: '',
				payment_id: '',
				remarks: '',
				services:[],
				
				// Dynamic data properties
				complaints: [],
				all_complaints: [], // Store all complaints for filtering
				status_filter: "",
				search_term: "",
				loading: false,
				selected_complaint_id: null,
				
				// Completed Modal Data
				isSubmittingCompleted: false,
				completedModalService: null,

				date_filter: '',
			};
		},
		computed: {
			// Show number of results
			resultsCount() {
				return this.complaints.length;
			}
		},
		created() {
			this.fetchServices();
		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchServices(page_url = null) {
				this.getToken();
				let url = "/staffs/supportServices?limit=" + this.listing_length  +  "&keyword=" + this.keyword +  "&status=" + this.status + "&date=" + this.date_filter;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.services = responseData.services.data;
						this.all_complaints =responseData.services.data;
						this.pagination = responseData.services.links;
						this.from = responseData.services.from;
						this.to = responseData.services.to;
						this.total = responseData.services.total;
						
					})
					.catch((err) => console.log(err));
			},


			openModal() {
				this.showModal();
			},

			onPaymentTypeChange() {
				// Reset payment amounts when payment type changes
				if (this.payment_type === '2') { // Online
					this.cash_amount = '';
				} else if (this.payment_type === '1') { // Cash
					this.online_amount = '';
					this.payment_id = '';
				} else if (this.payment_type === '3') { // Both
					// Keep both fields available
				}
			},

			// Calculate payment breakdown for validation
			getPaymentBreakdown() {
				if (!this.payment_type || this.payment_status !== '1') return null;
				
				const total = parseFloat(this.cost) || 0;
				const online = parseFloat(this.online_amount) || 0;
				const cash = parseFloat(this.cash_amount) || 0;
				
				if (this.payment_type === '2') { // Online
					return { total, online, cash: 0, isValid: Math.abs(total - online) < 0.01 };
				} else if (this.payment_type === '1') { // Cash
					return { total, online: 0, cash, isValid: Math.abs(total - cash) < 0.01 };
				} else if (this.payment_type === '3') { // Both
					return { total, online, cash, isValid: Math.abs(total - (online + cash)) < 0.01 };
				}
				
				return null;
			},

			closeModal() {
				this.hideModal();
			},

            updateStatus(id) {
                this.errors = {};
				this.complaint_status = 1;
                this.material_change = "";
				this.product_id = "";
				this.quantity = "";
				this.cost = "";
				this.payment_status = "";
				this.payment_type = "";
				this.online_amount = "";
				this.cash_amount = "";
				this.payment_id = "";
				this.remarks = "";
				this.modal_title = "Update Service Status";
				this.button_title = "Save";
				this.selected_complaint_id = id;
				this.showModal();
            },

			assignToSpeedtech(id) {
					this.delete = false;
					this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to assign this service to Speedtech?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                     this.getToken();
                     const config = {
                        headers: {
                              'Authorization': 'Bearer ' + this.token,
                        }
                     };
                     this.$axios
                     .get('/staffs/assignToSpeedtech?service_id=' + id, config)
                     .then(response => {
                        if(response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchServices();
                     })
                     .catch(error => {
                           if(error.response){
                              if(error.response.data.message){
                                 this.$swal("", error.response.data.message, "error");
                              } else {
                                 this.$swal("", "Something went wrong", "error");
                              }
                           } else {
                              this.$swal("", "Something went wrong", "error");
                           }
                           
                     });
					}
					
				});
			},


			searchIccid() {
				if (this.iccid_search.trim() === '') {
					this.filteredIccidList = [];
					return;
				}

				this.getToken();
				this.$axios.get('/staffs/fetchICCID', {
					params: { iccid: this.iccid_search },
					headers: { Authorization: `Bearer ${this.token}` }
				})
				.then((res) => {
					if (res.data.status === 'true') {
						this.filteredIccidList = res.data.data;
						} else {
						this.filteredIccidList = [];
						}
					})
				.catch((err) => {
					console.error('Error fetching ICCIDs:', err);
					this.filteredIccidList = [];
				});
			},

			selectIccid(iccid) {
				this.iccid_search = iccid.iccid;
				this.showIccidSuggestions = false;

				this.getToken();
				this.$axios.get('/staffs/getSimByICCID', {
					params: { iccid: iccid.iccid },
					headers: { Authorization: `Bearer ${this.token}` },
				})
				.then((res) => {
					if (res.data.status === 'true') {
						this.selectedIccid = res.data.data;
						} else {
						this.selectedIccid = null;
						this.$swal('Error', res.data.message || 'No SIM details found', 'error');
					}
				})
				.catch((err) => {
					console.error('Error fetching SIM details:', err);
					this.selectedIccid = null;
				});
			},


			// ========== Completed Modal Methods ==========
			paymentStatusLabel(val) {
				if (val == null || val === '') return '—';
				return String(val) === '1' ? 'Received' : String(val) === '2' ? 'Not Received' : val;
			},
			openCompletedModal(id) {
				this.selected_complaint_id = id;
				const service = this.services.find(s => s.id == id);
				this.completedModalService = service || null;
				if (service) {
					this.cost = service.total_amount != null && service.total_amount !== '' ? service.total_amount : "";
					this.payment_status = service.payment_status != null && service.payment_status !== '' ? String(service.payment_status) : "";
					this.payment_type = service.payment_type != null && service.payment_type !== '' ? String(service.payment_type) : "";
					this.online_amount = service.cash_online != null && service.cash_online !== '' ? service.cash_online : "";
					this.cash_amount = service.cash_in_hand != null && service.cash_in_hand !== '' ? service.cash_in_hand : "";
					this.payment_id = service.payment_id != null && service.payment_id !== '' ? service.payment_id : "";
				} else {
					this.cost = "";
					this.payment_status = "";
					this.payment_type = "";
					this.online_amount = "";
					this.cash_amount = "";
					this.payment_id = "";
				}
				this.isSubmittingCompleted = false;
				this.showCompletedModal();
			},

			closeCompletedModal() {
				this.hideCompletedModal();
				this.clearCompletedForm();
			},

			clearCompletedForm() {
				this.cost = "";
				this.payment_status = "";
				this.payment_type = "";
				this.online_amount = "";
				this.cash_amount = "";
				this.payment_id = "";
				this.selected_complaint_id = null;
				this.completedModalService = null;
				this.isSubmittingCompleted = false;
			},

			submitCompleted() {
				if (this.isSubmittingCompleted) return;

				if (!this.payment_status) {
					this.$swal('Error', 'Please select payment status', 'error');
					return;
				}

				// Free Service: amount may be 0, and payment_type/online/cash fields are not required
				if (this.payment_status !== '4') {
					if (this.cost === '' || this.cost === null || this.cost === undefined) {
						this.$swal('Error', 'Please enter total amount', 'error');
						return;
					}
				}

				if (this.payment_status === '1') {
					if (!this.payment_type) {
						this.$swal('Error', 'Please select payment type', 'error');
						return;
					}

					const total = parseFloat(this.cost) || 0;
					const online = parseFloat(this.online_amount) || 0;
					const cash = parseFloat(this.cash_amount) || 0;

					if ((this.payment_type === '2' && Math.abs(total - online) > 0.01) ||
						(this.payment_type === '1' && Math.abs(total - cash) > 0.01) ||
						(this.payment_type === '3' && Math.abs(total - (online + cash)) > 0.01)) {
						this.$swal('Error', 'Payment amounts do not match total', 'error');
						return;
					}
				}

				this.isSubmittingCompleted = true;
				this.getToken();

				const payload = {
					service_id: this.selected_complaint_id,
					total_amount: this.payment_status === '4' ? 0 : this.cost,
					payment_status: this.payment_status,
					remarks: this.remarks,
				};

				if (this.payment_status === '1') {
					payload.payment_type = this.payment_type;
					payload.cash_online = this.online_amount;
					payload.cash_in_hand = this.cash_amount;
					payload.payment_id = this.payment_id;
				}

				this.$axios.post('/staffs/completeWorkStatus', payload, {
					headers: { Authorization: "Bearer " + this.token }
				})
				.then(res => {
					this.isSubmittingCompleted = false;
					this.$swal('Success', res.data.message || 'Work completed successfully', 'success');
					this.closeCompletedModal();
					this.fetchServices();
				})
				.catch(err => {
					this.isSubmittingCompleted = false;
					this.$swal('Error', err.response?.data?.message || 'Failed to complete work', 'error');
					});
			},

			
			// Filter complaints based on search term and status
			filterServices() {
				let filtered = [...this.all_complaints];

				// Filter by search term
				if (this.search_term.trim()) {
					const searchTerm = this.search_term.toLowerCase().trim();
					filtered = filtered.filter(complaint => 
						complaint.imei.toLowerCase().includes(searchTerm) ||
						complaint.vehicle_no.toLowerCase().includes(searchTerm) ||
						complaint.contact.toLowerCase().includes(searchTerm) ||
						complaint.complaint_type.toLowerCase().includes(searchTerm)
					);
				}

				// Filter by status
				if (this.status_filter) {
					filtered = filtered.filter(complaint => complaint.status == this.status_filter);
				}

				this.complaints = filtered;
			},

			// Get status badge class
			getStatusClass(status) {
				const statusClasses = {
					1: "bg-info",
					2: "bg-primary", 
					3: "bg-success", // Completed
					4: "bg-warning", // Manufacturer
					5: "bg-warning", // Assigned to Speedtech
					6: "bg-secondary" // Assigned to Dealer
				};
				return statusClasses[status] || "bg-secondary";
			},

			// Get status text
			getStatusText(status) {
				const statusTexts = {
					1: "Pending",
					2: "Ongoing",
					3: "Completed", 
					4: "Manufacturer",
					5: "Assigned to Speedtech",
					6: "Assigned to Dealer"
				};
				return statusTexts[status] || "Unknown";
			},

			// Handle form submission for updating complaint status
			submitStatusUpdate() {
				if (!this.selected_complaint_id) {
					this.$swal('Error', 'No complaint selected', 'error');
					return;
				}

				// Validate required fields
				if (!this.complaint_status) {
					this.$swal('Error', 'Please select a status', 'error');
					return;
				}

				if (this.material_change === '1' && (!this.product_id || !this.quantity)) {
					this.$swal('Error', 'Please fill in material details', 'error');
					return;
				}

				if (this.complaint_status === '1' && !this.cost) {
					this.$swal('Error', 'Please enter the cost', 'error');
					return;
				}

				// Validate payment fields when status is completed
				if (this.complaint_status === '1') {
					if (!this.payment_status) {
						this.$swal('Error', 'Please select payment status', 'error');
						return;
					}

					if (this.payment_status === 'received') {
						if (!this.payment_type) {
							this.$swal('Error', 'Please select payment type', 'error');
							return;
						}

						if (this.payment_type === '1') { // Online
							if (!this.online_amount || !this.payment_id) {
								this.$swal('Error', 'Please enter online amount and payment ID', 'error');
								return;
							}
							
							// Validate that online amount equals total amount
							const totalAmount = parseFloat(this.cost) || 0;
							const onlineAmount = parseFloat(this.online_amount) || 0;
							
							if (Math.abs(totalAmount - onlineAmount) > 0.01) {
								this.$swal('Error', 'Online amount must equal the total amount', 'error');
								return;
							}
						} else if (this.payment_type === '2') { // Cash
							if (!this.cash_amount) {
								this.$swal('Error', 'Please enter cash amount', 'error');
								return;
							}
							
							// Validate that cash amount equals total amount
							const totalAmount = parseFloat(this.cost) || 0;
							const cashAmount = parseFloat(this.cash_amount) || 0;
							
							if (Math.abs(totalAmount - cashAmount) > 0.01) {
								this.$swal('Error', 'Cash amount must equal the total amount', 'error');
								return;
							}
						} else if (this.payment_type === '3') { // Both
							if (!this.online_amount || !this.cash_amount || !this.payment_id) {
								this.$swal('Error', 'Please enter both online and cash amounts, and payment ID', 'error');
								return;
							}
							
							// Validate that total amount equals sum of online and cash amounts
							const totalAmount = parseFloat(this.cost) || 0;
							const onlineAmount = parseFloat(this.online_amount) || 0;
							const cashAmount = parseFloat(this.cash_amount) || 0;
							
							if (Math.abs(totalAmount - (onlineAmount + cashAmount)) > 0.01) {
								this.$swal('Error', 'Total amount must equal the sum of online and cash amounts', 'error');
								return;
							}
						}
					}
				}

				// Simulate API call
				this.loading = true;
				setTimeout(() => {
					// Update the complaint status in the local data
					const complaintIndex = this.all_complaints.findIndex(c => c.id === this.selected_complaint_id);
					if (complaintIndex !== -1) {
						this.all_complaints[complaintIndex].status = parseInt(this.complaint_status);
						this.all_complaints[complaintIndex].status_text = this.getStatusText(parseInt(this.complaint_status));
						this.all_complaints[complaintIndex].status_class = this.getStatusClass(parseInt(this.complaint_status));
						
						// Add payment information if status is completed
						if (this.complaint_status === '1') {
							this.all_complaints[complaintIndex].payment_status = this.payment_status;
							this.all_complaints[complaintIndex].payment_type = this.payment_type;
							this.all_complaints[complaintIndex].total_amount = this.cost;
							
							if (this.payment_status === 'received') {
								if (this.payment_type === '1') { // Online
									this.all_complaints[complaintIndex].online_amount = this.online_amount;
									this.all_complaints[complaintIndex].payment_id = this.payment_id;
								} else if (this.payment_type === '2') { // Cash
									this.all_complaints[complaintIndex].cash_amount = this.cash_amount;
								} else if (this.payment_type === '3') { // Both
									this.all_complaints[complaintIndex].online_amount = this.online_amount;
									this.all_complaints[complaintIndex].cash_amount = this.cash_amount;
									this.all_complaints[complaintIndex].payment_id = this.payment_id;
								}
							}
						}
						
						// Refresh the filtered list
						this.filterServices();
					}

					this.loading = false;
					this.closeModal();
					
					// Show success message with payment details
					let successMessage = 'Service status updated successfully';
					if (this.complaint_status === '1' && this.payment_status === 'received') {
						const paymentTypeText = this.payment_type === '1' ? 'Online' : 
											  this.payment_type === '2' ? 'Cash' : 
											  this.payment_type === '3' ? 'Both' : '';
						successMessage += ` with ${paymentTypeText} payment`;
					}
					
					this.$swal('Success', successMessage, 'success');
				}, 1000);
			},
			
		},
	};
</script>